import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const InformationCard = ({
  icon,
  iconSize = 260,
  title,
  description,
  reserveDescriptionLines = false
}) => {
  return (
    <div className="flex w-full flex-col items-center gap-5">
      <Icon icon={icon} size={iconSize} />
      <div className="flex max-w-[460px] flex-col items-center gap-2 text-center">
        <Typography variant="h5" weight="semibold" color="neutral-900">
          {title}
        </Typography>
        {description && (
          <Typography
            variant="p"
            size="medium"
            color="neutral-700"
            className={cn('!text-base', reserveDescriptionLines && 'min-h-[3rem]')}>
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default InformationCard;
